var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Buffer } from "buffer";
import config from "../../../../../../assests/config";
import apiService from "../../../../../../helpers/apiService";
// import { getDateFormat } from "../../../../../../../utills/getFormatDate";
export const onFileUpload = (state, selectedMember, file, noMemberIdFile) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let fileName = "";
        if (file === "paymentProof" && !noMemberIdFile) {
            console.log("1 selectedMember::: !noMemberIdFile", selectedMember);
            fileName =
                selectedMember.serviceDate +
                    "_" +
                    selectedMember.memberId +
                    "_" +
                    "RECEIPT" +
                    "_" +
                    selectedMember.id +
                    "." +
                    selectedMember.paymentProof.blobFile.type.split("/")[1].toString();
        }
        else if (file !== "paymentProof" && !noMemberIdFile) {
            console.log("2 selectedMember::: !noMemberIdFile", selectedMember);
            fileName =
                selectedMember.serviceDate +
                    "_" +
                    selectedMember.memberId +
                    "_" +
                    "UB04" +
                    "_" +
                    selectedMember.id +
                    "." +
                    selectedMember.providerSuperbill.blobFile.type.split("/")[1].toString();
        }
        else if (file === "paymentProof" && noMemberIdFile) {
            console.log("3 selectedMember::: !noMemberIdFile", selectedMember);
            fileName =
                selectedMember.serviceDate +
                    "_" +
                    selectedMember.memberId +
                    "_" +
                    "RECEIPT" +
                    "_" +
                    noMemberIdFile.data.response.id +
                    "." +
                    selectedMember.paymentProof.blobFile.type.split("/")[1].toString();
        }
        else if (file !== "paymentProof" && noMemberIdFile) {
            console.log("4 selectedMember::: !noMemberIdFile", selectedMember);
            fileName =
                selectedMember.serviceDate +
                    "_" +
                    selectedMember.memberId +
                    "_" +
                    "UB04" +
                    "_" +
                    noMemberIdFile.data.response.id +
                    "." +
                    selectedMember.providerSuperbill.blobFile.type.split("/")[1].toString();
        }
        const formData = new FormData();
        formData.append("file", file === "paymentProof"
            ? selectedMember.paymentProof.blobFile
            : selectedMember.providerSuperbill.blobFile, fileName);
        const { data: apiResponse } = yield apiService.post({
            URL: config.API_URLS.NETWELL_MY_REIMBURSEMENT_DEV +
                config.API_URLS.MEMBER_PAYMENT_PROOF,
            data: formData,
        });
        return apiResponse.response;
    }
    catch (error) {
        console.log("onFileUpload error::: ", error);
        throw new Error((error === null || error === void 0 ? void 0 : error.message) || "");
    }
});
export const getAllFamilyMember = ({ memberid } = { memberid: "" }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let obj = {
            memberIdSource: localStorage.getItem("sourceid"),
            email: localStorage.getItem("userMail"),
            type: "",
        };
        let netwellOrganization = Buffer.from(`NETWELL;${new Date()}`).toString("base64");
        const { data: apiResponse } = yield apiService.post({
            URL: "https://dev.fabric.carynhealth.com/api/v1/csrportal/idcard",
            data: obj,
            headers: {
                "X-Tenant-Id": netwellOrganization,
                Authorization: "Bearer " + localStorage.getItem("bearerToken"),
            },
        });
        let selectedmemberData = {};
        if (memberid) {
            selectedmemberData = apiResponse.memberIdCardList.find((res) => {
                return res.empId == memberid;
            });
            if (Object.keys(selectedmemberData).length) {
                selectedmemberData = Object.assign(Object.assign({}, selectedmemberData), { memberName: selectedmemberData.firstName + " " + selectedmemberData.lastName });
            }
        }
        return {
            listMember: apiResponse.memberIdCardList,
            allMembers: apiResponse.memberIdCardList.map((data) => data.firstName + " " + data.lastName),
            selectedmemberData,
        };
    }
    catch (error) {
        console.log("getAllFamilyMember error:::::", error);
        return {
            message: (error === null || error === void 0 ? void 0 : error.message) || "",
        };
    }
});
export const getSelctedMemberRedeem = (empId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data: apiResponse } = yield apiService.get({
            URL: config.API_URLS.NETWELL_MY_REIMBURSEMENT_DEV +
                "memberportal/getReimbursementById/" +
                empId,
        });
        console.log(apiResponse);
    }
    catch (error) { }
});
